const merchantBadgeBodyWrapper = el('.merchant-badge-wrapper'),
  tabToggle = el('.toggles'),
  copyBtn = el('.copy-code'),
  emailform = el('.merchant-badge-form'),
  darkBtn = el('.dark-btn'),
  lightBtn = el('.light-btn'),
  darkBadgeCode = el('.dark-badge-code'),
  lightBadgeCode = el('.light-badge-code'),
  successMessage = el('.success-message');

let selectCodeBlock = darkBadgeCode.innerText;

function el(el) {
  return document.querySelector(el);
}

// Event Listener for Toggle Switch Effect
function toggleChanges(e) {
  const Nodes = (e.target || e.srcElement).childNodes[0].parentNode;

  if (Nodes.classList.contains('light-btn')) {
    merchantBadgeBodyWrapper.classList.remove('dark');
    selectCodeBlock = lightBadgeCode.innerText;
  } else {
    merchantBadgeBodyWrapper.classList.add('dark');
    selectCodeBlock = darkBadgeCode.innerText;
  }
}

tabToggle.addEventListener('click', toggleChanges, false);

// General Method for coping items to clipboard
const copyTextToClipboard = (text, elt) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }

  navigator.clipboard.writeText(text).then(
    function() {
      elt.innerText = 'Copied!';
      setTimeout(() => {
        elt.innerText = 'Copy Code';
      }, 3000);
    },
    function(err) {
      elt.innerText = "Could'nt copy!";
    }
  );
};

copyBtn.addEventListener('click', e => {
  copyTextToClipboard(selectCodeBlock, e.target || e.srcElement);
});

//Handling Email Template
emailform.addEventListener(
  'submit',
  e => {
    e.preventDefault();
    (e.target || e.srcElement).email.value = '';
    successMessage.style.display = 'block';
  },
  false
);
